const websiteVersion = process.env.NODE_ENV === 'development' ? '' : '9c3ea9f'

export default websiteVersion
